import { unstable_serialize } from "swr";
import query from "utils/query";
import Config from "components/config";
import ManufacturerDetails from "components/manufacturers/manufacturer-details";

// used for get static props
import MANUFACTURER_QUERY from "queries/manufacturer";
import ATTRACTIONS_QUERY from "queries/attractions";

export default function Manufacturer({ fallback }) {
  return (
    <Config fallback={fallback}>
      <ManufacturerDetails />
    </Config>
  );
}

export async function getStaticPaths() {
  // We'll build some of the top manufacturers
  const slugs = [];

  const paths = slugs.map((slug) => ({
    params: { manufacturer: slug },
  }));

  return { paths, fallback: "blocking" };
}

export async function getStaticProps({ params }) {
  const fallback = {};

  const variables = {
    slug: params.manufacturer,
  };

  const [manufacturerData] = await Promise.all([
    query(MANUFACTURER_QUERY, variables),
  ]);

  fallback[[unstable_serialize([MANUFACTURER_QUERY, variables])]] =
    manufacturerData;

  // Relies on data from the above

  const attractionsGeneratedQuery = ATTRACTIONS_QUERY(true, false);

  if (
    Array.isArray(manufacturerData?.manufacturers) &&
    manufacturerData?.manufacturers?.length
  ) {
    const perPage = 30;
    const startRange = 0;
    const attractionsVariables = {
      limit: perPage,
      start: startRange,
      manufacturer: manufacturerData?.manufacturers[0].id,
    };

    const [attractionsData] = await Promise.all([
      query(attractionsGeneratedQuery, attractionsVariables),
    ]);

    fallback[
      [unstable_serialize([attractionsGeneratedQuery, attractionsVariables])]
    ] = attractionsData;
  }

  return {
    props: {
      fallback,
    },
  };
}
